<template>
    <div class="animated fadeIn">
        <b-row v-if="loading">
            <b-col cols="12" md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
        <b-row v-if="!loading">
            <b-col cols="12" md="12">
                <component-header
                    :title="`Create Product - ${
                        catalogObj !== null ? catalogObj.name : ''
                    }`"
                    :hasSearch="false"
                    :hasReload="false"
                    :hasCreate="false"
                    :hasback="true"
                    @back-press="backNavigate"
                />
            </b-col>
            <b-col cols="12" sm="12">
                <b-card>
                    <ValidationObserver v-slot="{ invalid }" ref="observer">
                        <div>
                            <b-card v-if="userRole === 'Tenant'">
                                <b-row>
                                    <b-col cols="12" sm="12" md="6">
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Seller"
                                        >
                                            <eb-select
                                                type="text"
                                                :id="'selectSeller'"
                                                v-model="currentProvider"
                                                :options="partnerList"
                                                label="userName"
                                                placeholder="Select Seller"
                                                @input="changeSeller"
                                            ></eb-select>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-card
                                v-if="
                                    userRole === 'Partner' && enableManufacturer
                                "
                            >
                                <b-row>
                                    <b-col cols="12" sm="12" md="6">
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Manufacturer"
                                        >
                                            <eb-select
                                                type="text"
                                                :id="'selectmanufacturer'"
                                                v-model="currentProvider"
                                                :options="partnerList"
                                                label="userName"
                                                placeholder="Select Manufacturer"
                                                @input="changeManufacturer"
                                            ></eb-select>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-card
                                v-if="
                                    catalogObj &&
                                    catalogObj.variations &&
                                    catalogObj.variations.length > 0
                                "
                            >
                                <b-row>
                                    <b-col cols="12" sm="12" md="6">
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Product Type"
                                        >
                                            <eb-select
                                                type="text"
                                                :id="'selectPtype'"
                                                v-model="selectedProductType"
                                                :options="productTypes"
                                                label="name"
                                                placeholder="Select Product Type"
                                                @input="changeProductType"
                                            ></eb-select>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12" sm="12" md="6">
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Type"
                                        >
                                            <eb-select
                                                type="text"
                                                :id="'selecttype'"
                                                v-model="selectedCreationType"
                                                :options="Types"
                                                label="name"
                                                placeholder="Select Type"
                                                @input="changeCreationType"
                                            ></eb-select>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-card>
                                <b-row class="ml-5">
                                    <b-col
                                        sm="4"
                                        @click="() => showImagePicker('icon')"
                                    >
                                        <b-form-group
                                            label="Icon"
                                            label-for="Icon"
                                            id="Icon"
                                            :label-cols="7"
                                        ></b-form-group>
                                        <single-image
                                            :url="inputObj.images.icon"
                                            height="210px"
                                            width="180px"
                                            label="Browse for Icon"
                                        ></single-image>
                                    </b-col>
                                    <b-col
                                        sm="4"
                                        @click="
                                            () => showImagePicker('smallImage')
                                        "
                                    >
                                        <b-form-group
                                            label="Small Image"
                                            label-for="SmallImage"
                                            :label-cols="7"
                                            :horizontal="true"
                                        ></b-form-group>
                                        <single-image
                                            height="200px"
                                            width="180px"
                                            :url="inputObj.images.smallImage"
                                            label="Browse Small Image"
                                        ></single-image>
                                    </b-col>
                                    <b-col
                                        sm="4"
                                        @click="
                                            () => showImagePicker('bigImage')
                                        "
                                    >
                                        <b-form-group
                                            label="Big Image"
                                            label-for="BigImage"
                                            :label-cols="7"
                                            :horizontal="true"
                                        ></b-form-group>
                                        <single-image
                                            height="200px"
                                            width="180px"
                                            label="Browse for Big Image"
                                            :url="inputObj.images.bigImage"
                                        ></single-image>
                                    </b-col>
                                </b-row>
                                <!-- <b-row class="ml-5">
                <b-col sm="6">
                  <VueUploadMultipleImage
                    :data-images="alternateImages"
                    @change="setAlternateImages"
                  ></VueUploadMultipleImage>
                </b-col>
              </b-row> -->
                            </b-card>
                            <b-modal
                                v-model="showImageSelector"
                                centered
                                scrollable
                                size="lg"
                                class="modal-width-100"
                            >
                                <div class="p-2">
                                    <b-row>
                                        <div class="md-3">
                                            <v-switch
                                                class="pa-2"
                                                color="blue"
                                                v-model="showLibrary"
                                            ></v-switch>
                                            <span class="mr-2 mb-1"
                                                >Pick From Library</span
                                            >
                                        </div>
                                        <div
                                            class="md-3 ml-auto"
                                            v-if="!showLibrary"
                                        >
                                            <b-button
                                                @click="
                                                    $refs.imageUploader.click()
                                                "
                                                >Select and Upload New</b-button
                                            >
                                            <input
                                                class="d-none"
                                                ref="imageUploader"
                                                type="file"
                                                @change="
                                                    uploadImageFromSelector
                                                "
                                            />
                                        </div>
                                    </b-row>
                                    <b-row
                                        v-if="showLibrary"
                                        class="max-height-400 overflow-x-auto text-center"
                                    >
                                        <b-col
                                            v-for="(d, i) in imageLibraryList"
                                            :key="i"
                                            md="2"
                                            @click="
                                                setImageFromLibrary(d.images)
                                            "
                                        >
                                            <img
                                                :src="
                                                    d.images[
                                                        libraryImageSelector
                                                    ]
                                                "
                                                class="object-fit-contain"
                                                height="100px"
                                                width="100%"
                                            />
                                            {{ d.title }}
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-modal>
                        </div>
                        <div
                            v-for="(entry, idx) in attributesMap.entries()"
                            :key="idx"
                        >
                            <b-row>
                                <b-col
                                    v-for="(item, index) in entry[1]"
                                    :key="index"
                                    :md="['Array'].includes(item.type) ? 12 : 6"
                                    :style="{
                                        display:
                                            item.type !== 'Array' ||
                                            (item.type === 'Array' &&
                                                valuesMap[
                                                    item.name ? item.name : ''
                                                ] &&
                                                valuesMap[item.name][0])
                                                ? 'block'
                                                : 'none',
                                    }"
                                >
                                    <field
                                        v-if="
                                            item.name !== 'days' &&
                                            item.name !== 'Type' &&
                                            item.name !== 'b2bType'
                                        "
                                        :fieldType="item.type"
                                        :fieldName="item.name ? item.name : ''"
                                        :displayName="
                                            item.attributeLabel &&
                                            item.attributeLabel[tenantLang]
                                                ? item.attributeLabel[
                                                      tenantLang
                                                  ]
                                                : item.name
                                        "
                                        :onChange="
                                            updatingUI ? null : fieldChange
                                        "
                                        :value="item.defaultValue"
                                        :id="item._id"
                                        :isRequired="item.isRequired"
                                        :subFields="item.attributeItems"
                                        :level="0"
                                        :meta="[
                                            {
                                                name: item.name,
                                                type: item.type,
                                            },
                                        ]"
                                        :active="activeIndex"
                                        :index="index"
                                        :setActive="setActive"
                                        :UIConcern="item.UIConcern"
                                        :enumValues="item.enumValues"
                                        :arrayChange="arrayChange"
                                        :valuesMap="valuesMap"
                                        :visibility="
                                            item.visibility
                                                ? item.visibility.onCreate
                                                : true
                                        "
                                    />
                                    <b-row
                                        v-else-if="
                                            item.name === 'days' ||
                                            item.name === 'fullTime'
                                        "
                                    >
                                        <b-col>
                                            <v-select
                                                v-model="inputObj['days']"
                                                :items="languages"
                                                item-text="name"
                                                return-object
                                                label="Select Days"
                                                multiple
                                                chips
                                                hint="What are the days for service"
                                                persistent-hint
                                            ></v-select>
                                        </b-col>
                                        <b-col>
                                            <v-switch
                                                color="indigo"
                                                v-model="inputObj['fullTime']"
                                                :label="`fullTime`"
                                            ></v-switch>
                                        </b-col>
                                    </b-row>
                                    <card v-if="item.name === 'b2bType'">
                                        <label class="card-title">{{
                                            item.name
                                        }}</label>
                                        <b-col class="pb-1">
                                            <eb-select
                                                type="text"
                                                :id="'b2bType'"
                                                v-model="typeB2b"
                                                :options="selectB2b"
                                                :selected="typeB2b"
                                                label="text"
                                                placeholder="Select b2b Type"
                                            ></eb-select>
                                        </b-col>
                                    </card>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-if="isAddresscapture">
                            <b-row>
                                <b-col>
                                    <Card>
                                        <div class="wrap">
                                            <b-form-group>
                                                <p class="head">Location</p>
                                                <GmapAutocomplete
                                                    @place_changed="placechange"
                                                    :options="{
                                                        fields: [
                                                            'geometry',
                                                            'formatted_address',
                                                            'address_components',
                                                        ],
                                                    }"
                                                    class="mt-1 location-search"
                                                ></GmapAutocomplete>
                                            </b-form-group>
                                        </div>
                                    </Card>
                                </b-col>
                            </b-row>
                        </div>
                        <div
                            v-if="
                                catalogObj &&
                                catalogObj.variations &&
                                catalogObj.variations.length > 0 &&
                                selectedProductType.value === 'VARIABLE'
                            "
                        >
                            <a-divider />
                            <Variance
                                :isService="isService"
                                :varianceData="catalogVariations"
                                @change="onchangeVarianceData"
                                @changeDefault="changeDefault"
                            />
                        </div>
                        <a-divider />
                        <div class="form-actions text-center" v-if="!submitted">
                            <router-link to="/item">
                                <button
                                    class="mr-1 btn btn-danger"
                                    variant="danger"
                                >
                                    <span>Cancel</span>
                                </button>
                            </router-link>
                            <button
                                class="mr-1 btn btn-primary"
                                variant="facebook"
                                @click="handleSumit"
                                :disabled="invalid"
                            >
                                <span>Save Item</span>
                            </button>
                        </div>
                        <div class="form-action text-center" v-else>
                            <v-progress-circular
                                :indeterminate="true"
                                color="light-blue"
                            />
                        </div>
                    </ValidationObserver>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import cTable from "@/views/base/Table.vue";
import Field from "@/components/Item/Field";
import Card from "@/components/Generics/Card.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import Variance from "@/components/Variance/Variance.vue";
import locationMixins from "@/mixins/addressLocation";
import SingleImage from "@/components/Common/Image.vue";
import VueUploadMultipleImage from "@/components/FormElements/VueUploadMultipleImage";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";

const PRODUCT_TYPES = [
    { name: "Normal", value: "NORMAL" },
    { name: "Variable", value: "VARIABLE" },
];

const CREATION_TYPES = [
    { name: "Product", value: "PRODUCT" },
    { name: "Service", value: "SERVICE" },
];

const DAYS_OF_WEEK = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
];

const B2B_TYPE_OPTIONS = [
    { text: "Sell to Customer", value: 0 },
    { text: "Sell to Merchant", value: 1 },
    { text: "Sell to Both", value: 2 },
];

const ATTRIBUTE_TYPES = new Set([
    "String",
    "Number",
    "Object",
    "Array",
    "Boolean",
]);

const ADDRESS_ATTRIBUTE_NAMES = new Set([
    "Address",
    "State",
    "Country",
    "City",
    "Area",
    "Lat",
    "Lng",
]);

export default {
    name: "createItem",
    components: {
        cSwitch,
        cTable,
        field: Field,
        Card,
        SingleImage,
        ebSelect,
        Variance,
        VueUploadMultipleImage,
        ValidationObserver,
        ValidationProvider,
        ComponentHeader,
        AtomSpinner,
    },
    mixins: [locationMixins],
    props: {
        context: {
            type: String,
        },
    },
    data() {
        return {
            loading: false,
            submitted: false,
            updatingUI: false,
            activeIndex: null,
            libraryImageSelector: "",
            showImageSelector: false,
            showLibrary: false,
            selectedProductType: "NORMAL",
            selectedCreationType: "PRODUCT",
            currentProvider: "",
            typeB2b: {},
            catalogObj: null,
            attributesMap: new Map(),
            valuesMap: {},
            isAddresscapture: false,
            enableManufacturer: false,
            inputObj: {
                Name: "",
                description_summary: "",
                provider: null,
                catalogId: "",
                images: {
                    icon: "",
                    smallImage: "",
                    bigImage: "",
                    alternateImages: [],
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            tenantLang: "tenant/GetTenantLanguage",
            imageLibraryList: "catalog/GetImageLibraryList",
            getPartnerPaymentPreferencesGetter:
                "partner/getPartnerPaymentPreferencesGetter",
            partnerAllData: "partner/GetPartnerData",
        }),
        userRole() {
            if (this.$store.getters["auth/getUserRole"]) {
                return this.$store.getters["auth/getUserRole"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
            }
        },
        userTenantId() {
            return JSON.parse(sessionStorage.getItem("userLogin"))["tenant"];
        },
        productTypes() {
            return PRODUCT_TYPES;
        },
        Types() {
            return CREATION_TYPES;
        },
        languages() {
            return DAYS_OF_WEEK;
        },
        selectB2b() {
            return B2B_TYPE_OPTIONS;
        },
        partnerList() {
            const data = this.$store.getters["partner/GetPartnerList"];
            const partnerList = [];

            if (this.enableManufacturer && this.userRole === "Partner") {
                if (Array.isArray(data) && data.length > 0) {
                    data.forEach((obj) => {
                        if (obj.category === "MANUFACTURER") {
                            partnerList.push({
                                _id: obj._id,
                                userName: obj.authentication.userName,
                                email: obj.authentication.email,
                                phone: obj.authentication.phone,
                                ...obj,
                            });
                        }
                    });
                }
                return partnerList;
            } else {
                if (Array.isArray(data) && data.length > 0) {
                    data.forEach((obj) => {
                        partnerList.push({
                            _id: obj._id,
                            userName: obj.authentication.userName,
                            email: obj.authentication.email,
                            phone: obj.authentication.phone,
                            ...obj,
                        });
                    });
                }
                return partnerList;
            }
        },
        addressObj() {
            return this.$store.getters["item/GetCurrentCatalogLocation"];
        },
        isService() {
            if (
                !this.catalogObj ||
                !this.catalogObj.variations ||
                this.catalogObj.variations.length === 0
            ) {
                return false;
            }
            return this.catalogObj.variations.some(
                (obj) => obj.attrRef.attributeName === "slotTitle",
            );
        },
        catalogVariations() {
            if (
                !this.catalogObj ||
                !this.catalogObj.variations ||
                this.catalogObj.variations.length === 0
            ) {
                return [];
            }
            return this.catalogObj.variations.filter(
                (obj) => obj && obj.attrRef && obj.attrRef.attributeName,
            );
        },
    },
    methods: {
        ...mapActions({
            Getpartnerlist: "partner/fetchPartnersList",
            getImageLibraryList: "catalog/listImageLibrary",
            createLibrary: "catalog/createImageLibrary",
            getPartnerPaymentPreferencesAction:
                "partner/getPartnerPaymentPreferencesAction",
        }),
        getAttributeTypeByName(name) {
            if (!this.attributesMap) return null;
            for (let [type, arr] of this.attributesMap.entries()) {
                if (arr && arr.find((x) => x.attributeName === name))
                    return type;
            }
            return null;
        },
        convertToAttrType(value, attrType) {
            if (typeof value === "undefined" || value === null) return value;
            if (!attrType) return value;
            try {
                if (attrType === "String") return value.toString();
                if (attrType === "Number")
                    return typeof value === "number" ? value : Number(value);
                if (attrType === "Boolean") return Boolean(value);
                return value;
            } catch (e) {
                return value;
            }
        },
        initializeAttributesMap() {
            const defaultStrAttributes = [
                { type: "String", name: "Title", _id: "9" },
            ];
            return new Map([
                ["String", defaultStrAttributes],
                ["Number", []],
                ["Object", []],
                ["Array", []],
                ["Boolean", []],
            ]);
        },
        initializeValuesMap() {
            return { Title: "" };
        },
        shouldExcludeAttribute(attributeName) {
            return ADDRESS_ATTRIBUTE_NAMES.has(attributeName);
        },
        applySpecialAttributeDefaults(item) {
            const name = item.attributeRef.attributeName;
            if (name === "sellerContact") {
                item.defaultValue = this.$currentUserData.phone;
            }
            if (name === "IsSellable") {
                this.inputObj["IsSellable"] = true;
            }
        },
        buildInitialAttributeValue(attributeType, attributeObj) {
            if (["String", "Number"].includes(attributeType)) {
                return "";
            } else if (attributeType === "Boolean") {
                return false;
            } else if (attributeType === "Object") {
                return {};
            } else if (attributeType === "Array") {
                return this.buildArrayInitialValue(attributeObj);
            }
            return null;
        },
        buildArrayInitialValue(attributeObj) {
            const uiConcern = attributeObj.UIConcern;

            if (["Checkbox"].includes(uiConcern)) {
                return attributeObj.attributeItems;
            } else if (uiConcern === "Radio") {
                return null;
            } else if (uiConcern === "Select") {
                return [];
            } else if (uiConcern === "Object") {
                const temp = {};
                for (
                    let i = 0;
                    i < Object.keys(attributeObj.attributeItems).length;
                    i++
                ) {
                    const key = attributeObj.attributeItems[i].attributeName;
                    temp[key] = "";
                }
                return [temp];
            }
            return [];
        },
        processExternalAttributes(externalAttributes) {
            const attributesMap = this.initializeAttributesMap();
            const valuesMap = this.initializeValuesMap();
            externalAttributes.forEach((item) => {
                if (!item.attributeRef) return;
                const attributeName = item.attributeRef.attributeName;
                if (attributeName === "Address") {
                    this.isAddresscapture = true;
                    return;
                }
                if (this.shouldExcludeAttribute(attributeName)) {
                    return;
                }
                this.applySpecialAttributeDefaults(item);
                const attributeType = item.attributeRef.attributeValueType;
                if (!ATTRIBUTE_TYPES.has(attributeType)) {
                    return;
                }
                const attributeObj = {
                    ...item,
                    ...item.attributeRef,
                    type: attributeType,
                    name: attributeName,
                };
                const existingAttributes =
                    attributesMap.get(attributeType) || [];
                attributesMap.set(attributeType, [
                    ...existingAttributes,
                    attributeObj,
                ]);
                const initialValue = this.buildInitialAttributeValue(
                    attributeType,
                    attributeObj,
                );
                if (initialValue !== null) {
                    valuesMap[attributeName] = initialValue;
                    if (attributeType === "Boolean") {
                        this.inputObj[attributeName] = false;
                    }
                }
            });
            return { attributesMap, valuesMap };
        },
        updateAttributesMapDefaults(fieldUpdates) {
            const updateField = (attributes, updates) => {
                return attributes.map((attr) => {
                    const updated = { ...attr };
                    Object.keys(updates).forEach((fieldName) => {
                        if (attr.attributeName === fieldName) {
                            updated.defaultValue = updates[fieldName];
                        }
                    });
                    return updated;
                });
            };
            const stringAttrs = this.attributesMap.get("String") || [];
            const numberAttrs = this.attributesMap.get("Number") || [];
            this.attributesMap = new Map([
                ["String", updateField(stringAttrs, fieldUpdates)],
                ["Number", updateField(numberAttrs, fieldUpdates)],
                ["Object", this.attributesMap.get("Object") || []],
                ["Array", this.attributesMap.get("Array") || []],
                ["Boolean", this.attributesMap.get("Boolean") || []],
            ]);
        },
        backNavigate() {
            if (this.userRole === "Tenant") {
                this.$router.push({
                    name: "partner-item",
                    params: { id: this.partnerAllData._id },
                });
            } else {
                this.$router.push("/item");
            }
        },
        showImagePicker(selector) {
            this.libraryImageSelector = selector;
            this.showImageSelector = true;
        },
        uploadImageFromSelector(e) {
            const file = e.target.files[0];
            if (!file || !file.type.match("image.*")) {
                this.$toasted.error("Invalid File format");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {
                const image = event.target.result;
                this.uploadImage(this.libraryImageSelector, image);
                this.$refs["imageUploader"].value = "";
            };
            reader.readAsDataURL(file);
        },
        setImageFromLibrary(images) {
            this.inputObj.images[this.libraryImageSelector] =
                images[this.libraryImageSelector];
            this.libraryImageSelector = "";
            this.showImageSelector = false;
        },
        async uploadImage(type, image) {
            this.showImageSelector = false;

            const dataobj = {
                image: image,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: ["seller", "items"],
            };
            this.showCustomToast();
            try {
                const res = await this.$store.dispatch(
                    "inventory/uploadImageToStorage",
                    dataobj,
                );
                if (res) {
                    this.clearCustomToast();
                    this.setImageUrl(type, res.data.fileUrl);
                }
            } catch (error) {
                this.clearCustomToast();
                this.$toasted.error("Image not uploaded..please try again!");
            }
        },
        setImageUrl(type, url) {
            if (type === "icon") {
                this.inputObj.images.icon = url;
            } else if (type === "smallImage") {
                this.inputObj.images.smallImage = url;
            } else {
                this.inputObj.images.bigImage = url;
            }
        },
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },
        validateImages() {
            return !!(
                this.inputObj.images.icon &&
                this.inputObj.images.smallImage &&
                this.inputObj.images.bigImage
            );
        },
        validateStockCountForStandardItem(payload) {
            const inventory = payload.Inventory;
            const isStandard = inventory === "STANDARD_ITEM";
            if (!isStandard) return true;

            const stockCount =
                payload.StockCount !== undefined ? payload.StockCount : null;
            const stockCountNum = Number(stockCount);

            if (!stockCount || Number.isNaN(stockCountNum) || stockCountNum <= 0) {
                this.$swal({
                    title: "Error",
                    text: "StockCount must be greater than 0 for STANDARD_ITEM inventory",
                    type: "error",
                });
                return false;
            }

            // For VARIABLE products, also validate within variations if present.
            if (Array.isArray(payload.variations) && payload.variations.length) {
                for (const variant of payload.variations) {
                    const inv =
                        variant?.attributes?.Inventory !== undefined
                            ? variant.attributes.Inventory
                            : inventory;
                    if (inv !== "STANDARD_ITEM") continue;
                    const vStock = variant?.attributes?.StockCount;
                    const vStockNum = Number(vStock);
                    if (!vStock || Number.isNaN(vStockNum) || vStockNum <= 0) {
                        this.$swal({
                            title: "Error",
                            text: "StockCount must be greater than 0 for STANDARD_ITEM inventory",
                            type: "error",
                        });
                        return false;
                    }
                }
            }

            return true;
        },
        fieldChange(data) {
            if (this.updatingUI) return;

            const fieldMeta = data.meta[0];
            const fieldName = fieldMeta.name;
            const fieldType = fieldMeta.type;
            const fieldValue = data.value;

            if (fieldName === "Name") {
                this.inputObj.Name = fieldValue;
                this.inputObj.description_summary = fieldValue;
                return;
            }
            this.updateFieldValue(fieldName, fieldType, fieldValue);
            this.syncAttributeValueToVariations(fieldName, fieldValue);
            this.handleDiscountCalculations(fieldName, fieldType);
        },
        syncAttributeValueToVariations(fieldName, fieldValue) {
            if (
                !this.inputObj.variations ||
                !Array.isArray(this.inputObj.variations) ||
                this.inputObj.variations.length === 0
            ) {
                return;
            }

            this.inputObj.variations.forEach((variant) => {
                if (!variant || !variant.attributes) return;
                variant.attributes[fieldName] = fieldValue;
            });
        },
        updateFieldValue(fieldName, fieldType, value) {
            if (fieldName === "Title") return;
            if (fieldType === "String") {
                this.inputObj[fieldName] = value;
            } else if (fieldType === "Number") {
                this.inputObj[fieldName] =
                    typeof value === "string" ? Number(value) : value;
            } else if (fieldType === "Boolean" || fieldType === "Object") {
                this.inputObj[fieldName] = value;
            }
        },
        handleDiscountCalculations(fieldName, fieldType) {
            if (!["String", "Number"].includes(fieldType)) {
                return;
            }
            if (fieldName === "Price") {
                this.recalculateDealPriceFromPrice();
                return;
            }
            if (!this.inputObj["Price"]) return;
            if (fieldName === "Discount(%)") {
                this.calculateDiscountFromPercentage();
            } else if (fieldName === "Discount") {
                this.calculateDiscountFromAmount();
            }
        },
        recalculateDealPriceFromPrice() {
            if (!this.inputObj["Price"] || this.inputObj["Price"] <= 0) return;
            const discountPercentage = this.inputObj["Discount(%)"];
            if (
                discountPercentage !== undefined &&
                discountPercentage !== null &&
                discountPercentage !== "" &&
                !isNaN(discountPercentage) &&
                discountPercentage >= 0
            ) {
                this.calculateDiscountFromPercentage();
                return;
            }
            const discount = this.inputObj["Discount"];
            if (
                discount !== undefined &&
                discount !== null &&
                discount !== "" &&
                !isNaN(discount) &&
                discount >= 0
            ) {
                this.calculateDiscountFromAmount();
            }
        },
        calculateDiscountFromPercentage() {
            if (!this.inputObj["Price"] || !this.inputObj["Discount(%)"])
                return;
            this.updatingUI = true;
            const discountAmount =
                this.inputObj["Price"] * (this.inputObj["Discount(%)"] / 100);
            const dealPrice = this.inputObj["Price"] - discountAmount;
            this.inputObj["Discount"] = parseFloat(discountAmount.toFixed(2));
            this.inputObj["Deal Price"] = parseFloat(dealPrice.toFixed(2));
            this.inputObj["Discount(%)"] = parseFloat(
                this.inputObj["Discount(%)"],
            ).toFixed(2);
            this.updateDiscountFieldsInAttributesMap();
            setTimeout(() => {
                this.updatingUI = false;
            }, 1000);
        },
        calculateDiscountFromAmount() {
            if (
                !this.inputObj["Price"] ||
                this.inputObj["Discount"] === undefined
            )
                return;

            this.updatingUI = true;
            const discountAmount = parseFloat(
                parseFloat(this.inputObj["Discount"]).toFixed(2),
            );
            this.inputObj["Discount"] = discountAmount;
            const dealPrice = this.inputObj["Price"] - discountAmount;
            this.inputObj["Discount(%)"] = (
                (discountAmount / this.inputObj["Price"]) *
                100
            ).toFixed(2);
            this.inputObj["Deal Price"] = parseFloat(dealPrice.toFixed(2));
            this.updateDiscountFieldsInAttributesMap();
            setTimeout(() => {
                this.updatingUI = false;
            }, 1000);
        },
        updateDiscountFieldsInAttributesMap() {
            const fieldUpdates = {
                "Deal Price": this.inputObj["Deal Price"],
                Discount: this.inputObj["Discount"],
                "Discount(%)": this.inputObj["Discount(%)"],
            };
            this.updateAttributesMapDefaults(fieldUpdates);
        },
        changeDefault(val) {
            if (!val) return;
            const fieldUpdates = {};
            const firstAttributeKey = Object.keys(val.attributes)[0];
            if (firstAttributeKey) {
                fieldUpdates[firstAttributeKey] =
                    val.attributes[firstAttributeKey];
            }
            if (val.DealPrice > 0) {
                fieldUpdates["Deal Price"] = val.DealPrice;
            }
            if (val.Discount > 0) {
                fieldUpdates["Discount"] = val.Discount;
            }
            if (val.DiscountPercentage > 0) {
                fieldUpdates["Discount(%)"] = val.DiscountPercentage;
            }
            if (val.Inventory !== undefined) {
                fieldUpdates["Inventory"] = val.Inventory;
            }
            if (val.StockCount !== undefined) {
                fieldUpdates["StockCount"] = val.StockCount;
            }
            if (val.Price !== undefined && val.DealPrice > 0) {
                const numberAttrs = this.attributesMap.get("Number") || [];
                numberAttrs.forEach((attr) => {
                    if (attr.attributeName === "Price") {
                        attr.defaultValue = val.Price;
                    }
                });
            }
            this.updateAttributesMapDefaults(fieldUpdates);
        },
        arrayChange(data) {
            const { index, type, e, fieldName, meta, action, arrObj } = data;
            let temp = this.valuesMap;
            let parent = temp;
            let path = "";
            for (let i = 0; i < meta.length; i++) {
                const item = meta[i];
                if (
                    ["Object", "String", "Number", "Array"].includes(item.type)
                ) {
                    parent = temp;
                    path = item.name;
                    temp = temp[item.name];
                }
            }
            switch (type) {
                case "check":
                    this.$set(temp[index], "checked", e.target.checked);
                    break;
                case "select":
                case "radio":
                    this.$set(parent, fieldName, e);
                    break;
            }
            if (arrObj === true) {
                switch (action) {
                    case "change":
                        this.$set(
                            parent,
                            path,
                            temp.map((item, idx) =>
                                idx === index
                                    ? { ...item, [fieldName]: e }
                                    : item,
                            ),
                        );
                        break;
                    case "add":
                        const tObj = {};
                        const keys = Object.keys(temp[0] || {});
                        keys.forEach((key) => {
                            tObj[key] = "";
                        });
                        this.$set(parent, path, temp.concat([tObj]));
                        break;
                    case "remove":
                        temp.splice(index, 1);
                        break;
                }
            }
        },
        setActive(i) {
            this.activeIndex = this.activeIndex === i ? -1 : i;
        },
        async getCatalog() {
            try {
                const result = await this.$store.dispatch(
                    "catalog/fetchCatalogById",
                    this.inputObj.catalogId,
                );

                if (result.status !== 0) {
                    this.catalogObj = result.response;
                    const { attributesMap, valuesMap } =
                        this.processExternalAttributes(
                            result.response.externalAttributes,
                        );
                    this.attributesMap = attributesMap;
                    this.valuesMap = valuesMap;
                }
            } catch (error) {
                console.error("Error loading catalog:", error);
            }
        },
        async handleSumit() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;
            if (!this.validateImages()) {
                this.$swal({
                    title: "Error",
                    text: "Upload all images",
                    type: "error",
                });
                return;
            }
            this.normalizeValuesMap();
            this.normalizeVariations();
            this.applyDefaultVariationValues();
            this.applyAddressData();
            const payload = this.buildFinalPayload();
            if (!this.validateStockCountForStandardItem(payload)) return;
            this.submitted = true;
            await this.dispatchCreateItem(payload);
        },
        normalizeValuesMap() {
            Object.keys(this.valuesMap).forEach((key) => {
                const value = this.valuesMap[key];
                if (
                    Array.isArray(value) &&
                    value.length > 0 &&
                    value[0] &&
                    value[0].value
                ) {
                    this.valuesMap[key] = value.map((v) => v.value);
                }
            });
        },
        normalizeVariations() {
            if (
                !this.inputObj.variations ||
                this.inputObj.variations.length === 0
            ) {
                this.inputObj.variations = [];
                return;
            }
            const variations = this.isService
                ? this.normalizeServiceVariations()
                : this.normalizeProductVariations();

            this.inputObj.variations = variations;
        },
        normalizeProductVariations() {
            return this.inputObj.variations.map((obj) => {
                const normalized = {
                    attributes: obj.attributes,
                    isDefault: obj.isDefault,
                    Price: +obj.Price,
                    DealPrice: +obj.DealPrice,
                };
                if (!obj.Discount) {
                    normalized.Discount = 0;
                    normalized.DiscountPercentage = obj.DiscountPercentage;
                } else {
                    normalized.Discount = +obj.Discount;
                    if (!obj.DiscountPercentage) {
                    }
                }
                return normalized;
            });
        },
        normalizeServiceVariations() {
            return this.inputObj.variations.map((obj) => ({
                attributes: obj.attributes,
                isDefault: obj.isDefault,
                slotLimit: obj.slotLimit,
                Price: +obj.Price,
            }));
        },
        applyDefaultVariationValues() {
            if (
                !this.inputObj.variations ||
                this.inputObj.variations.length === 0
            ) {
                return;
            }
            const defaultVariation = this.inputObj.variations.find(
                (v) => v.isDefault,
            );

            if (!defaultVariation) return;
            Object.keys(defaultVariation.attributes).forEach((key) => {
                this.inputObj[key] = defaultVariation.attributes[key];
            });
            if (!this.isService && defaultVariation.Price) {
                this.inputObj.Price = +defaultVariation.Price;
            }
            if (this.isService && this.inputObj.days) {
                this.inputObj.days = this.inputObj.days.join(",");
            }
        },
        applyAddressData() {
            if (!this.isAddresscapture) return;

            if (this.addressObj.data) {
                const fields = Object.keys(this.addressObj.data);
                fields.forEach((field) => {
                    if (field !== "zip") {
                        this.inputObj[field] = this.addressObj.data[field];
                    }
                });
                this.inputObj.Lng = this.addressObj.Lng;
                this.inputObj.Lat = this.addressObj.Lat;
                this.inputObj.Address = {
                    Lng: this.inputObj.Lng,
                    Lat: this.inputObj.Lat,
                    City: this.inputObj.City,
                    State: this.inputObj.State,
                    Country: this.inputObj.Country,
                    Address: this.addressObj.address,
                };
                this.inputObj.Area = this.addressObj.address;
            } else if (this.itemObj && this.itemObj.Address) {
                this.inputObj.City = this.itemObj.Address.City;
                this.inputObj.Country = this.itemObj.Address.Country;
                this.inputObj.State = this.itemObj.Address.State;
                this.inputObj.Lat = this.itemObj.Address.Lat;
                this.inputObj.Lng = this.itemObj.Address.Lng;
                this.inputObj.Address = {
                    Lng: this.inputObj.Lng,
                    Lat: this.inputObj.Lat,
                    City: this.inputObj.City,
                    State: this.inputObj.State,
                    Country: this.inputObj.Country,
                    Address: this.itemObj.Address.Address,
                };
                this.inputObj.Area = this.itemObj.Address.Address;
            }
        },
        buildFinalPayload() {
            const payload = {
                ...this.valuesMap,
                ...this.inputObj,
            };
            const resolvedCatalogId =
                payload.catalogId ||
                this.inputObj.catalogId ||
                this.$route.params.id;
            payload.catalogId = resolvedCatalogId;
            this.inputObj["b2bType"] = `${this.typeB2b.value}`;
            if (this.inputObj.hasOwnProperty("IsSellable")) {
                this.inputObj.IsSellable = this.inputObj.IsSellable
                    ? "TRUE"
                    : "FALSE";
            }
            payload.description_summary = payload.Name;
            if (this.inputObj.ToDate) {
                payload.FromDate = this.inputObj.FromDate;
                payload.ToDate = this.inputObj.ToDate;
            }
            delete payload.Title;
            const dealPriceAttrType = this.getAttributeTypeByName("Deal Price");
            this.inputObj["Deal Price"] = this.convertToAttrType(
                this.inputObj["Deal Price"],
                dealPriceAttrType,
            );
            this.inputObj.isDeleted = false;
            return payload;
        },
        async dispatchCreateItem(payload) {
            try {
                const result = await this.$store.dispatch(
                    "item/createItem",
                    payload,
                );

                if (result.status === 1) {
                    this.$swal({
                        title: "Success",
                        text: "Item has been created successfully",
                        type: "success",
                    });
                    this.submitted = false;
                    this.$router.push("/item");
                }
            } catch (error) {
                this.$swal({
                    title: "Error",
                    text: error.message.message,
                    type: "error",
                });
                this.submitted = false;
            }
        },

        changeSeller(event) {
            this.inputObj.provider = this.currentProvider
                ? this.currentProvider._id
                : null;
        },

        changeProductType(event) {
            this.inputObj.productType = this.selectedProductType
                ? this.selectedProductType.value
                : "NORMAL";
        },

        changeCreationType(event) {
            this.inputObj.Type = this.selectedCreationType
                ? this.selectedCreationType.value
                : "PRODUCT";
        },

        changeManufacturer(event) {
            this.inputObj.manufacturerId = this.currentProvider
                ? this.currentProvider._id
                : null;
        },
        onchangeVarianceData(data) {
            this.inputObj.variations = data;
        },
        initializeForm() {
            this.inputObj.productType = this.selectedProductType;
            const userID = this.$store.getters["auth/getUserID"];
            this.inputObj.provider = userID;
            this.inputObj.catalogId = this.$route.params.id;
        },
        async loadCatalog() {
            await this.getCatalog();
        },
        async loadPartners() {
            if (this.userRole === "Tenant") {
                await this.Getpartnerlist();
            }
        },
        loadImageLibrary() {
            this.getImageLibraryList(this.inputObj.catalogId);
        },
        async initializePartnerSettings() {
            if (this.userRole !== "Partner") return;
            await this.loadTenantDetails();
            await this.loadPartnerPaymentPreferences();
            this.setDefaultB2bType();
        },
        async loadTenantDetails() {
            try {
                const response = await this.$store.dispatch(
                    "tenant/getTenantDetailByID",
                    this.userTenantId,
                );
                if (response && response.response) {
                    this.enableManufacturer = response.response.preferences
                        ? response.response.preferences.enableManufacturer
                        : false;

                    if (this.enableManufacturer) {
                        this.$store.dispatch(
                            "partner/fetchPartnersListByType",
                            "MANUFACTURER",
                        );
                    }
                }
            } catch (error) {
                console.error("Error loading tenant details:", error);
            }
        },
        async loadPartnerPaymentPreferences() {
            await this.getPartnerPaymentPreferencesAction(
                this.$currentUserData._id,
            );
        },
        setDefaultB2bType() {
            const preferences =
                this.getPartnerPaymentPreferencesGetter.preferences;
            if (
                !preferences ||
                !preferences.buySell ||
                !preferences.buySell.sell
            ) {
                return;
            }
            const { b2b, b2c } = preferences.buySell.sell;

            if (b2b === true && b2c === false) {
                this.typeB2b = { text: "Sell to Merchant", value: 1 };
            } else if (b2b === false && b2c === true) {
                this.typeB2b = { text: "Sell to Customer", value: 0 };
            } else if (b2b === true && b2c === true) {
                this.typeB2b = { text: "Sell to Both", value: 2 };
            }
        },
    },
    async mounted() {
        this.loading = true;
        this.initializeForm();
        await this.loadCatalog();
        await this.loadPartners();
        this.loadImageLibrary();
        await this.initializePartnerSettings();
        this.loading = false;
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.card-wrap {
    border: none !important;
    box-shadow: 0px 0px 10px 1px rgb(235, 235, 235) !important;
    border-radius: 1px !important;
}

.flex-row {
    display: flex;
}

.wrap {
    margin: 10px;
}

.head {
    font-size: 1.2em;
    font-weight: 900;
}

.location-search {
    border-radius: 0rem;
    color: rgb(0, 0, 0);
    box-shadow: none !important;
    font-family: "Lato";
    height: 39px !important;
    border: 1px solid #dee2e6;
    padding-left: 10px;
    width: 100%;
    font-size: small;
}

.border-blue {
    border: 4px solid lightskyblue;
}

.card-title {
    font-size: 1em;
    font-weight: 800;
    padding-left: 14px;
    padding-top: 10px;
}

</style>
